<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <el-row :gutter="50" style="margin-left:0;margin-right:0">

        <el-col :span="12">
          <el-form-item label="模板名称" prop="name">
            <el-input v-model="form_data.name" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="模板编码" prop="code">
            <el-input v-model="form_data.code" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="缩写" prop="abbreviation">
            <el-input v-model="form_data.abbreviation" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-show="this.$props.id==null">
          <el-form-item label="选择消防柜模板" prop="template_id">
            <el-select v-model="form_data.template_id" placeholder="请选择消防柜模板" >
              <el-option v-for="item in template_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :span="12">
          <el-form-item label="启用状态" prop="is_active">
            <el-switch v-model="form_data.is_active" :active-value="1" :inactive-value="0" active-text="启用状态">
            </el-switch>
          </el-form-item>
        </el-col>
        
      </el-row>

    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>
import {
  types
} from './lavel.js';
// console.log(types)
export default {
  name: 'l-cabinet-template-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    place_type: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    useType: {
      type: [Number],
      default: 1
    },
  },

  components: {
  },
  computed: {
    hasId() {
      return this.$props.id != null;
    },
    place_type_list() {
      return this.$store.state.list.place_type_list
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();

        }
      }
    },

  },
  data() {
    return {
      loading: false,//页面是否加载中
      LAVEL_LIST: types,
      //是否显示
      tree_node: [

      ],
      //表单数据
      form_data: {
        is_node: 0,
        pid: "",
        name: '',
        department_level: '',
        abbreviation: '',
        place_type: '',
        is_public: 1,
        is_active: 1,
      },
      nodeList: [],
      type_name: "",
      template_list: [],
      //表单验证规则
      rules: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'change' }
        ],
        abbreviation: [
          { required: true, message: '缩写不能为空', trigger: 'change' }
        ],
        code: [
          { required: true, message: '编码不能为空', trigger: 'change' }
        ],
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },
  mounted() {

  },


  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    func_click(e) {
      if (this.form_data.type == '' && e) {
        this.$alert('请先选择等级', '提示', {
          confirmButtonText: '确定'
        });
      }
    },

    //获取数据
    getData() {
      if (!this.hasId) {
          this.$_invoke(`trainTemplate_saveData`, ).then((ret) => {
          console.log(ret);
            this.tree_node = ret.tree_node;
            this.template_list = ret.template_list;
          }).finally(() => {
            this.loading = false;
          });
      } else {
        this.loading = true;
        this.$_invoke(`trainTemplate_details`, { id: this.$props.id }).then((ret) => {
          this.form_data = ret.data;
          // this.tree_node = ret.superior;
          this.getdata_flag = true
        }).finally(() => {
          this.loading = false;
        });
      }

    },


    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {

        if (valid) {
          this.submitting = true;
          if (!this.hasId) {//添加
            this.$_invoke('trainTemplate_saveTemplate', this.form_data).then(() => {
              this.$_msg.success('添加成功');
              this.$emit('on-success');
            }).finally(() => {
              this.submitting = false;
            })
          } else {//修改
            this.$_invoke(`trainTemplate_updateTemplate`, {
              id: this.$props.id,
              ...this.form_data
            }).then(() => {
              this.$_msg.success('修改成功');
              this.$emit('on-success');
            }).finally(() => {
              this.submitting = false;
            })
          }
        }
      })

    },
  },
}
</script>